jQuery(function ($) {
    $(document).ready(function(){

        $('[data-toggle="tooltip"]').tooltip();
        function onclickForm(){
            if($("#real-inscription, #contact-content").length){
                grecaptcha.ready(function () {
                    grecaptcha.execute(recaptcha_user, { action: 'contact' }).then(function (token) {
                        setTimeout(function() {
                            var recaptchaResponse = document.getElementById('recaptchaResponse');
                            recaptchaResponse.value = token;
                        }, 500);
                    });
                });
            }

            if($("#real-inscription").length) {
                $("#user_save, #user_temp_save").on("click", function (e) {

                    e.preventDefault();

                    if ($("#user_temp_save").length > 0) {
                        fullForm = false;
                    } else {
                        fullForm = true;
                    }

                    grecaptcha.ready(function() {
                        grecaptcha.execute(recaptcha_user, {action: 'submit'}).then(function(token) {

                            $.ajax({
                                type: "post",
                                url: Routing.generate('cf_core_check_captcha'),
                                data: {"token": token, "email": $("#user_email").val()},
                                success : function(data, statut){
                                    if(data){
                                        $(".row-form").removeClass("error error-field-open");
                                        $form = $("#register_form");

                                        var $submitButton = $form.find(":submit");
                                        $submitButton.html("<i class='fa fa-spinner fa-pulse'></i>");
                                        $submitButton.prop("disabled", true);

                                        $form.ajaxSubmit({
                                            type: "post",
                                            data: {"fullForm" : fullForm},
                                            success: function (data) {
                                                if(data != -1) {
                                                    if (data[0] != false) {
                                                        window.location.replace(Routing.generate('cf_core_form_style_steps', {"step": 1, "newRegist": true}));
                                                    } else {
                                                        $("#register_form").replaceWith(data[1]);
                                                        onclickForm();
                                                    }
                                                }
                                            },
                                            error: function (jqXHR, status, error) {
                                                $("#register_form").submit();
                                            },
                                            complete: function (resultat, statut) {
                                                $submitButton.html("Inscription");
                                                $submitButton.prop("disabled", false);
                                            }
                                        });
                                    }
                                },
                                error : function(resultat, statut, erreur){

                                },
                                complete : function(resultat, statut){

                                }
                            });
                        });
                    });
                });
            }else if($("#contact-content").length) {
                e.preventDefault();
                ev = e;
                grecaptcha.ready(function() {
                    grecaptcha.execute(recaptcha_user, {action: 'submit'}).then(function(token) {

                        $.ajax({
                            type: "post",
                            url: Routing.generate('cf_core_check_captcha'),
                            data: {"token": token},
                            success : function(data, statut){
                                if(data){
                                    ev.currentTarget.submit();
                                }
                            },
                            error : function(resultat, statut, erreur){

                            },
                            complete : function(resultat, statut){

                            }
                        });
                    });
                });
            } else {
                $(".register-form form[name=user]").submit(function (e) {

                    e.preventDefault();
                    ev = e;

                    grecaptcha.ready(function() {
                        grecaptcha.execute(recaptcha_user, {action: 'submit'}).then(function(token) {

                            $.ajax({
                                type: "post",
                                url: Routing.generate('cf_core_check_captcha'),
                                data: {"token": token, "email": $("#user_email").val()},
                                success : function(data, statut){
                                    if(data){
                                        ev.currentTarget.submit();
                                    }
                                },
                                error : function(resultat, statut, erreur){

                                },
                                complete : function(resultat, statut){

                                }
                            });
                        });
                    });
                });
            }
        }

        onclickForm();

        $('#wrapp-error').click(function(){
            $("#wrapp-error").removeClass("open");
            $('#input_error').removeClass('bad good');
        });

        $('.scrollTo').click( function() { 
            var page = $(this).attr('href');
            $('html, body').animate( { scrollTop: $(page).offset().top - 60 }, 500 + "ease");
            return false;
        });

        $('.show-password').click( function() { 
            if( $(this).hasClass("open") ){
                $(this).removeClass("open");
                $(".password-to-show").attr('type','password');
            }
            else{
                $(this).addClass("open");
                $(".password-to-show").attr('type','text');
            }
            
        });

        if($('.js-homepage__scroll').length > 0 && $("#inscription").length > 0){
            $( window ).scroll(function() {
                if(
                    $(window).scrollTop() > $('.js-homepage__scroll').offset().top &&
                    $(window).scrollTop() < ($('#inscription').offset().top - $(window).height())
                ){
                    if(!$('.c-navigation .js-btn__show').hasClass('js-btn__active')){
                        $('.c-navigation .js-btn__show').addClass('js-btn__active');
                    }
                    if(!$('.c-navigation').hasClass('js-navigation__active')){
                        $('.c-navigation').addClass('js-navigation__active');
                    }
                }
                else{
                    if($('.c-navigation .js-btn__show').hasClass('js-btn__active')){
                        $('.c-navigation .js-btn__show').removeClass('js-btn__active');
                    }
                    if($('.c-navigation').hasClass('js-navigation__active')){
                        $('.c-navigation').removeClass('js-navigation__active');
                    }
                }
            });
        }

        $(".js-form__field--mimic-select").click(function(){
            if($(".js-form__field--mimic-select-dropdown").hasClass("open")){
                $(".js-form__field--mimic-select-dropdown").removeClass("open");
            }
            else{
                $(".js-form__field--mimic-select-dropdown").addClass("open");
            }
        });

        $(".js-form__field--mimic-select > .flag-icon").click(function(){
            if($(".js-form__field--mimic-select-dropdown").hasClass("open")){
                $(".js-form__field--mimic-select-dropdown").removeClass("open");
            }
            else{
                $(".js-form__field--mimic-select-dropdown").addClass("open");
            }
        });

        $(window).click(function(event){
            if (!$(event.target).hasClass("js-form__field--mimic-select-dropdown") &&
                !$(event.target).hasClass("js-form__field--mimic-select-li") &&
                !$(event.target).hasClass("js-form__field--mimic-select") &&
                !$(event.target).hasClass("js-form__field--mimic-select-flag")){

                $(".js-form__field--mimic-select-dropdown").removeClass("open");
            }
        });

        $(".js-form__field--mimic-select-li").click(function(){
            var id = $(this).data("id");

            $("#countryId").val(id);
            $(".js-form__field--mimic-select-dropdown").removeClass("open");

            var html = $(this).html();
            $(".js-form__field--mimic-select").html(html);
        });

        //////////////////////////

        $(".js-form__field--mimic-select-small").click(function(){
            if($(".js-form__field--mimic-select-dropdown-small").hasClass("open")){
                $(".js-form__field--mimic-select-dropdown-small").removeClass("open");
            }
            else{
                $(".js-form__field--mimic-select-dropdown-small").addClass("open");
            }
        });

        $(".js-form__field--mimic-select-small > .flag-icon").click(function(){
            if($(".js-form__field--mimic-select-dropdown-small").hasClass("open")){
                $(".js-form__field--mimic-select-dropdown-small").removeClass("open");
            }
            else{
                $(".js-form__field--mimic-select-dropdown-small").addClass("open");
            }
        });

        $(window).click(function(event){
            if (!$(event.target).hasClass("js-form__field--mimic-select-dropdown-small") &&
                !$(event.target).hasClass("js-form__field--mimic-select-li-small") &&
                !$(event.target).hasClass("js-form__field--mimic-select-small") &&
                !$(event.target).hasClass("js-form__field--mimic-select-flag-small")){

                $(".js-form__field--mimic-select-dropdown-small").removeClass("open");
            }
        });

        $(".js-form__field--mimic-select-li-small").click(function(){
            var id = $(this).data("id");
            var countryCode = $(this).data("code");

            $(".js-form__field--mimic-select-dropdown-small").removeClass("open");
            $(".js-form__field--mimic-select-small").css("background", "url('/flags/4x3/"+countryCode+".svg') no-repeat 15px center");
            // $(".js-form__field--mimic-select-small").css("background-size", "21px 16px");
            $(".js-form__field--mimic-select-small").css("background-size", "5px 3px");

            var url = window.location.href.split('?')[0] + "?country=" + countryCode;

            window.location.href = url;
        });

        $('.slick-carousel').slick({
            arrows: true,
            dots: true,
        });

        if($(window).width() > 630){
            $('.slick-carousel-3').slick({
                arrows: true,
                dots: false,
                slidesToShow: 3,
            });
        }
        else{
            $('.slick-carousel-3').slick({
                arrows: true,
                dots: false,
                slidesToShow: 1,
            });
        }

        // Carrousel Homepage Intro

        if($(window).width() < 850 ){
            var scrollLeft = 10;
            $(".block_carrousel").scrollLeft(scrollLeft);
            $(".block_carrousel2").scrollLeft(scrollLeft);

            $("#intro-carrousel-arrow-right").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() + 420;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#intro-carrousel-arrow-right2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() + 420;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#intro-carrousel-arrow-left").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() - 420;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#intro-carrousel-arrow-left2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() - 420;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 400);
            })
        } else if ($(window).width() >= 850 && $(window).width() < 1000 ){
            var scrollLeft = 395;
            $(".block_carrousel").scrollLeft(scrollLeft);
            $(".block_carrousel2").scrollLeft(scrollLeft);

            $("#intro-carrousel-arrow-right").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() + 410;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#intro-carrousel-arrow-right2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() + 410;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#intro-carrousel-arrow-left").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() - 410;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#intro-carrousel-arrow-left2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() - 410;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 400);
            })
        } else if ($(window).width() >= 1000 && $(window).width() < 1500){
            var scrollLeft = 250;
            $(".block_carrousel").scrollLeft(scrollLeft);
            $(".block_carrousel2").scrollLeft(scrollLeft);

            $("#intro-carrousel-arrow-right").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() + 820;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-right2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() + 820;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-left").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() - 820;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-left2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() - 820;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 800);
            })
        } else if ($(window).width() >= 1500 && $(window).width() < 1800){
            var scrollLeft = 800;
            $(".block_carrousel").scrollLeft(scrollLeft);
            $(".block_carrousel2").scrollLeft(scrollLeft);

            $("#intro-carrousel-arrow-right").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() + 820;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-right2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() + 820;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-left").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() - 820;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-left2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() - 820;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 800);
            })
        }  else if ($(window).width() >= 1800){
            var scrollLeft = 750;
            $(".block_carrousel").scrollLeft(scrollLeft);
            $(".block_carrousel2").scrollLeft(scrollLeft);

            $("#intro-carrousel-arrow-right").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() + 810;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-right2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() + 810;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-left").click(function(){
                var scrollLeft = $(".block_carrousel").scrollLeft() - 810;
                $(".block_carrousel").animate({scrollLeft: scrollLeft}, 800);
            })

            $("#intro-carrousel-arrow-left2").click(function(){
                var scrollLeft = $(".block_carrousel2").scrollLeft() - 810;
                $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 800);
            })
        }
        else{
            if($("#intro-carousel2").length > 0){
                var scrollLeft = $("#intro-carousel2").position().left - (($(window).width() - $("#intro-carousel2").position().left) / 2);
                $(".block_carrousel").scrollLeft(scrollLeft);
                $(".block_carrousel2").scrollLeft(scrollLeft);

                $("#intro-carrousel-arrow-right").click(function(){
                    var scrollLeft = $(".block_carrousel").scrollLeft() + 265;
                    $(".block_carrousel").animate({scrollLeft: scrollLeft}, 200);
                });

                $("#intro-carrousel-arrow-right2").click(function(){
                    var scrollLeft = $(".block_carrousel2").scrollLeft() + 265;
                    $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 200);
                });

                $("#intro-carrousel-arrow-left").click(function(){
                    var scrollLeft = $(".block_carrousel").scrollLeft() - 265;
                    $(".block_carrousel").animate({scrollLeft: scrollLeft}, 200);
                });

                $("#intro-carrousel-arrow-left2").click(function(){
                    var scrollLeft = $(".block_carrousel2").scrollLeft() - 265;
                    $(".block_carrousel2").animate({scrollLeft: scrollLeft}, 200);
                });
            }
        }

        // Carrousel Block 6

        if($(window).width() >= 1000){
            var scrollLeft = 250;
            $(".block_6").scrollLeft(scrollLeft);

            $("#carrousel-arrow-right").click(function(){
                var scrollLeft = $(".block_6").scrollLeft() + 530;
                //$(".block_6").scrollLeft(scrollLeft);

                $(".block_6").animate({scrollLeft: scrollLeft}, 400);
            })

            $("#carrousel-arrow-left").click(function(){
                var scrollLeft = $(".block_6").scrollLeft() - 530;
                //$(".block_6").scrollLeft(scrollLeft);

                $(".block_6").animate({scrollLeft: scrollLeft}, 400);
            })
        }
        else{
            if($("#carousel2").length > 0){
                var scrollLeft = $("#carousel2").position().left - (($(window).width() - $("#carousel2").position().left) / 2);
                $(".block_6").scrollLeft(scrollLeft);

                $("#carrousel-arrow-right").click(function(){
                    var scrollLeft = $(".block_6").scrollLeft() + 265;
                    //$(".block_6").scrollLeft(scrollLeft);

                    $(".block_6").animate({scrollLeft: scrollLeft}, 200);
                });

                $("#carrousel-arrow-left").click(function(){
                    var scrollLeft = $(".block_6").scrollLeft() - 265;
                    //$(".block_6").scrollLeft(scrollLeft);

                    $(".block_6").animate({scrollLeft: scrollLeft}, 200);
                });
            }
        }

        $(document).ready(function () {
            function displayWindowSize() {
                var w = $(window).width();

                // var chevron = $(".bi-chevron-down");
                //
                // if (chevron.length) {
                //     if (w < 992) {
                //         chevron.removeClass("hidden");
                //     } else {
                //         chevron.addClass("hidden");
                //     }
                // }

                // var chevronRefMob = $(".chevron-mobil");
                // var chevronRefDesktop = $(".chevron-desktop");

                // if (chevronRefMob.length || chevronRefDesktop.length ){
                //     if (w < 768) {
                //         chevronRefMob.removeClass("hidden");
                //         chevronRefDesktop.addClass("hidden");
                //     } else {
                //         chevronRefDesktop.removeClass("hidden");
                //         chevronRefMob.addClass("hidden");
                //     }
                // }
            }

            displayWindowSize();
            $(window).on("load", displayWindowSize);
            $(window).on("resize", displayWindowSize);
        });

        if($("#faq-toggle-btn").length){
            for (let i = 0; i <= 4; i++){
                let isToggled = false;
                $(`#inner-wrap-question-${i}`).click(function(){
                     $(`#toggle-answer-${i}`).toggle(".invisible");
                    if (isToggled) {
                        $(`.icon-${i}`).css({ transform: "rotate(0deg) translateZ(0) ", pointerEvents: "auto" });
                    } else {
                        $(`.icon-${i}`).css({ transform: "rotate(90deg) translateZ(0)", pointerEvents: "none" });
                    }
                   isToggled = !isToggled;
                })
            }
        };


        $window = $(window);
        $('.slide-show').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.slide-show',
            dots: true,
            focusOnSelect: true,
            autoplay: false,
            arrows: false,
            responsive: [{
                breakpoint: 800,
                settings: {
                   slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    centerMode: false,
                }
            }, ]
        });

        $(window).resize(function() {
            $('.slick-carousel-3').slick("unslick");

            if($(window).width() > 630){
                $('.slick-carousel-3').slick({
                    arrows: true,
                    dots: false,
                    slidesToShow: 3,
                });
            }
            else{
                $('.slick-carousel-3').slick({
                    arrows: true,
                    dots: false,
                    slidesToShow: 1,
                });
            }
        });

        $('.slick-carousel-photos').slick({
            arrows: true,
            dots: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 4000,
        });

        hideButtons = false;
        $(".coeur-barre").click(function(){
            $(".js-appreciation-img").last().removeClass("js-appreciation-img").css("z-index", 100).animate({
                opacity: 0,
                left: "-=200px"
            }, 500, function() {
                if($(".js-appreciation-img").length >= 1){
                    $(this).remove();
                }
                else{
                    $(this).css("opacity", 0);
                    hideButtons = true;
                }
            });

            if($(".js-appreciation-img").length <= 0){
                $(".coeur-barre").hide();
                $(".coeur").hide();
                $(".appreciation-last-slide").show();
            }
        });

        hideButtons = false;
        $(".coeur").click(function(){
            $(".js-appreciation-img").last().removeClass("js-appreciation-img").css("z-index", 100).animate({
                opacity: 0,
                left: "+=200px"
            }, 500, function() {
                if($(".js-appreciation-img").length >= 1){
                    $(this).remove();
                }
                else{
                    $(this).css("opacity", 0);
                    hideButtons = true;
                }
            });

            if($(".js-appreciation-img").length <= 0){
                $(".coeur-barre").hide();
                $(".coeur").hide();
                $(".appreciation-last-slide").show();
            }
        });

        if($(".appreciation-last-slide").length){
            /*if($(window).width() <= 1080 && $(window).width() > 450) {
                $(".appreciation-last-slide").css("height", "400px");
                setTimeout(function(){
                    $(".appreciation-last-slide").css("height", $(".appreciation-img").css("height"));
                }, 2000);
            }

            $(window).resize(function() {
                if($(window).width() > 1080){
                    $(".appreciation-last-slide").css("height", "557px");
                }
                else if($(window).width() > 450){
                    if($(".appreciation-img").length){
                        $(".appreciation-last-slide").css("height", $(".appreciation-img").css("height"));
                    }
                    else{
                        $(".appreciation-last-slide").css("height", "465px");
                    }
                }
                else{
                    $(".appreciation-last-slide").css("height", "275px");
                }
            });*/
        }

        /*if($(".c-btn--register#user_save").length){
            $(".c-btn--register#user_save").html("<span class='arrow-text'>" +
                "JE COMMENCE" +
                "</span>");
        }*/
    });

    if($(".contact-form").length){

        $(".contact-form form").submit(function(e) {
            e.preventDefault();

            $form = $("#register_form");
            var $submitButton = $form.find(":submit");
            $submitButton.html("<i class='fa fa-spinner fa-pulse'></i>");
            $submitButton.prop("disabled", true);
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_user, {action: 'contactForm'}).then(function(token) {

                    $.ajax({
                        type: "post",
                        url: Routing.generate('cf_core_check_captcha'),
                        data: {"token": token, "email": $("#user_email").val()},
                        success : function(data, statut){
                            if(data){
                                $('form').unbind('submit').submit();
                            }
                        },
                        error : function(resultat, statut, erreur){

                        },
                        complete : function(resultat, statut){
                            $submitButton.html("Envoyer le message");
                        }
                    });
                });
            });
        });

        $("#subject").change(function(){
            $(".other-question-category").slideUp();
            if($(".other-question-category#" + ($(this).find("option:selected").data("slug"))).length){
                $(".other-question-category#" + ($(this).find("option:selected").data("slug"))).slideDown();
            }
        });
    }

    $(".input-form-1, .c-form__field--checkbox").each(function(){
        $(this).click(function(){
            $(this).parent().removeClass("error").removeClass("error-field-open");
        });
    })

    if($(".extended_return_date_page").length) {
        $("#extended_return_date").datepicker({
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: "dd-mm-yy",
            prevText: 'Mois précédent',
            nextText: 'Mois suivant',
            monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
            dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
            dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
            weekHeader: 'Sem.',
            firstDay: 1,
            beforeShowDay: function(date){
                var string      = jQuery.datepicker.formatDate('dd-mm-yy', date);
                var cssClass    = '';
                var available   = true;

                for (var i = 0; i < hiddenDates.length; i++) {
                    var element = hiddenDates[i];
                    if(element == string){
                        available = false;
                    }
                    // Add css class on the line
                    cssClass = 'ui-datepicker-current-day';
                }

                return [available, cssClass];
            },
        }).keyup(function (e) {
            e.preventDefault();
        });
    }

    if($("#my-subscription").length){
        $(".cancel-deadline").click(function(){
            var text = $(this).parent().text().replace("Annuler", "").trim();

            $(".deadline-date").text(text);
            $("#subscriptionDeadLineDate").val($(this).data("date"));

            $(".cancel-deadline-modal-wrapper").show();
        });

        $(".restore-deadline").click(function(){
            var text = $(this).parent().text().replace("Rétablir", "").trim();

            $(".deadline-date").text(text);
            $("#subscriptionDeadLineDate").val($(this).data("date"));

            $(".restore-deadline-modal-wrapper").show();
        });

        $(".deadline-button-keep, .deadline-button-let").click(function(){
            $(".cancel-deadline-modal-wrapper, .restore-deadline-modal-wrapper").hide();
        });

        $(".cancel-deadline-modal-wrapper, .restore-deadline-modal-wrapper").click(function(){
            $(".cancel-deadline-modal-wrapper, .restore-deadline-modal-wrapper").hide();
        }).children().click(function(e) {
            return false;
        });

        $(".deadline-button-cancel").click(function(){
            $.ajax({
                type: "post",
                data: {"subscriptionDeadLineDate": $("#subscriptionDeadLineDate").val()},
                url: Routing.generate('cf_core_subscriptions_cancel_deadline'),
                success: function(data){
                    if(data){
                        //window.location.replace("#deadlines-list-wrapper");
                        window.location.href = "#deadlines-list-wrapper";
                        location.reload();
                    }
                    else{
                        $(".cancel-deadline-modal-wrapper").hide();
                        $(".subscription-deadline-error").show();
                    }
                },
                error : function(resultat, statut, erreur){

                },
                complete : function(resultat, statut){

                }
            });
        });

        $(".deadline-button-restore").click(function(){
            $.ajax({
                type: "post",
                data: {"subscriptionDeadLineDate": $("#subscriptionDeadLineDate").val()},
                url: Routing.generate('cf_core_subscriptions_restore_deadline'),
                success: function(data){
                    if(data){
                        //window.location.replace("#deadlines-list-wrapper");
                        window.location.href = "#deadlines-list-wrapper";
                        location.reload();
                    }
                    else{
                        $(".restore-deadline-modal-wrapper").hide();
                        $(".subscription-deadline-error").show();
                    }
                },
                error : function(resultat, statut, erreur){

                },
                complete : function(resultat, statut){

                }
            });
        });
    }

    if($("#modifier-frequence-livraison").length) {

        if($(".subcription-option").length){
            $(".subcription-option").click(function(){
                $(".subcription-option").each(function(){
                    $(this).removeClass("selected-subscription");
                });

                $(this).addClass("selected-subscription");

                var subscription_periodicity_text = $(this).find(".subscription-option-title").text();

                $(".subscription-periodicity-text").text(subscription_periodicity_text);

                $("#subscriptionTypeId").val($(this).data("id"));

                $.ajax({
                    type: "post",
                    data: {"subscriptionTypeId": $(this).data("id")},
                    url: Routing.generate('cf_core_simulate_subscription'),
                    success: function(data){

                        $(".deadlines-list").html("");

                        for(var i = 0; i < data.deadlines.length; i++){
                            html = "<tr><td>" +
                                data.deadlines[i] +
                                "</td></tr>";

                            $(".deadlines-list").append(html);
                        }
                    },
                    error : function(resultat, statut, erreur){

                    },
                    complete : function(resultat, statut){

                    }
                });
            });
        }
    }

    if($("#pause-abonnement").length){
        $("#pause_end_date").datepicker({
            minDate: minDatePauseNbDays,
            maxDate: 365,
            defaultDate: minDatePauseNbDays,
            dateFormat: "dd MM yy",
            prevText: 'Mois précédent',
            nextText: 'Mois suivant',
            monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
            dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
            dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
            weekHeader: 'Sem.',
            firstDay: 1,
            onSelect: function(date, inst) {
                selectedTimestamp = Date.parse(inst.currentYear + "-" + (inst.currentMonth + 1) + "-" + inst.currentDay) / 1000;
                //putMissedDatesToGray(selectedTimestamp);
                getNextSelection(selectedTimestamp);

                $("#pauseEnd").val(selectedTimestamp);
            },
        }).keyup(function(e){
            e.preventDefault();
        });

        getNextSelection(defaultDate);

        function getNextSelection(timestamp){
            for (var i = 0; i < nextSelections.length; i++){
                if(timestamp <= nextSelections[i]){
                    var date = new Date(nextSelections[i] * 1000);

                    $(".next-selection-text").text(date.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
                    break;
                }
            }
        }

        /*putMissedDatesToGray(defaultDate);

        function putMissedDatesToGray(timestamp){
            $(".incoming-selections").each(function(){
                $(this).removeClass("grey-td");

                if(timestamp >= $(this).data("timestamp")){
                    $(this).addClass("grey-td");
                }
            });
        }*/
    }

    if($(".js-useSamePaymentMethod").length){
        // $(".js-useSamePaymentMethod").click(function(){
        //     setTimeout(function(){
        //         $(".js-useSamePaymentMethod").submit();
        //     }, 300);
        // });


        $(".js-useSamePaymentMethod").change(function() {
            if (!$(this).is(":checked")) {
                $(".js-useDifferentPaymentMethod").show();
                $(".js-useSamePaymentMethod-block").hide();
            } else {
                $(".js-useSamePaymentMethod-block").show();
                $(".js-useDifferentPaymentMethod").hide();
            }
        });
    }

    if($("#footer-menu-mobile-toggle-button").length){
        $("#footer-menu-mobile-toggle-button").click(function(){
            if($(".footer-menu-mobile-hidden").hasClass("footer-menu-mobile-shown")){
                $(".footer-menu-mobile-hidden").removeClass("footer-menu-mobile-shown");
                $("#footer-menu-plus").show();
                $(".social-wrap-duplicate").hide();
                $("#footer-menu-minus").hide();
                $(".social-wrap-duplicate").show();
            }
            else{
                $(".footer-menu-mobile-hidden").addClass("footer-menu-mobile-shown")
                $("#footer-menu-plus").hide();
                $(".social-wrap-duplicate").show();
                $("#footer-menu-minus").show();
                $(".social-wrap-duplicate").hide();
            }
        });
    }

    if ($("#cf_core_suivi_parrainage").length) {
        $("[id^='emailAgain']:not([disabled])").on("click", function() {
            t = $(this);
            $.ajax({
                type: "post",
                url: Routing.generate('cf_core_relaunch_email'),
                data: {"id": $(this).val()},
                success: function (data) {
                    if (data["done"] === 1) {
                        t.prop('disabled', true);
                    }
                },
                error: function (resultat, statut, erreur) {

                },
                complete: function (resultat, statut) {

                }
            });
        });
    }

    if ($("#step-delivery-week-info").length) {
        var reservationDuration = 30 * 60;
        var startTime = Date.now();

        function updateTimer() {
            console.log("test")
            var elapsed = Math.floor((Date.now() - startTime) / 1000);
            var remaining = reservationDuration - elapsed;

            if (remaining <= 0) {
                $("#countdown").text('00:00');
                clearInterval(intervalId);
                return;
            }

            var minutes = Math.floor(remaining / 60);
            var seconds = remaining % 60;

            var mm = (minutes < 10 ? '0' + minutes : minutes);
            var ss = (seconds < 10 ? '0' + seconds : seconds);
            $("#countdown").text(mm + ':' + ss);
        }

        var intervalId = setInterval(updateTimer, 1000);
        updateTimer();
    }

});
